import { get as _get } from 'lodash';
import cookie from 'react-cookie';
import {
  fetchWindWave,
  fetchForecasts,
  fetchWrittenForecasts,
} from '../common/api/forecast';
import { fetchNearbyRegionByCoordinates } from '../common/api/cms';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';
import forecastTransform from '../utils/forecasts/forecastTransform';
import { getUserLegacySettings, getUserBwWindWaveModel } from '../selectors/user';

export const FETCH_FORECAST = 'FETCH_FORECAST';
export const FETCH_FORECAST_SUCCESS = 'FETCH_FORECAST_SUCCESS';
export const FETCH_FORECAST_FAILURE = 'FETCH_FORECAST_FAILURE';
export const FORECAST_PRINT_VERSION = 'FORECAST_PRINT_VERSION';
export const CLOSE_FORECAST_HEADER_ALERT = 'CLOSE_FORECAST_HEADER_ALERT';
export const IS_FORECAST_HEADER_ALERT_OPEN = 'IS_FORECAST_HEADER_ALERT_OPEN';

export const fetchForecast = (coordinates, interval = 360) => async (dispatch, getState) => {
  dispatch({
    type: FETCH_FORECAST,
  });
  try {
    const legacyUserSettings = getUserLegacySettings(getState());
    const bwWindWaveModel = getUserBwWindWaveModel(getState());
    const userStateDetails = _get(getState(), 'user.details', {});
    let forecast = {};
    const { forecast: { printVersion } } = getState();
    if (bwWindWaveModel === 'LOLA' || printVersion) {
      const newWrittenForecast = await fetchWrittenForecasts(
        coordinates[0], coordinates[1], userStateDetails);
      const newDataForecast = await fetchForecasts(
        coordinates[0], coordinates[1], interval, userStateDetails);
      forecast = forecastTransform(
        newDataForecast,
        newWrittenForecast,
        legacyUserSettings,
        printVersion,
      );
    } else {
      const nearbyRegion = await fetchNearbyRegionByCoordinates(coordinates);
      const grb = nearbyRegion && nearbyRegion.region_model_grb ?
        nearbyRegion.region_model_grb : 'enp';
      forecast = await fetchWindWave(
        coordinates[0],
        coordinates[1],
        bwWindWaveModel,
        grb,
        userStateDetails,
      );
    }
    await dispatch({
      type: FETCH_FORECAST_SUCCESS,
      forecast,
      interval,
    });
  } catch (error) {
    dispatch({
      type: FETCH_FORECAST_FAILURE,
      error,
    });
    if (error.statusCode >= 400 && error.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: `Forecast for ${coordinates} could not be found`,
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: `Forecast for ${coordinates} error`,
      });
    }
  }
};

export const isForecastPrintVersion = printVersion => async (dispatch) => {
  dispatch({ type: FORECAST_PRINT_VERSION, printVersion });
};

export const closeForecastHeaderAlert = () => async (dispatch) => {
  dispatch({ type: CLOSE_FORECAST_HEADER_ALERT });
  cookie.save('bw_forecast_header_alert', false, {
    path: '/',
    domain: location.hostname,
    maxAge: 31536000, // 1 year
    expires: new Date((new Date()).getTime() + (31536000 * 1000)),
  });
};



// WEBPACK FOOTER //
// ./src/actions/forecast.js